define('modules/editor/models/element_factory',['require','exports','module','base/class','./property_group_factory','underscore','./elements/text','./elements/form','./elements/form_button','./elements/button','./elements/video','./elements/image','./elements/html','./elements/social','./elements/popup'],function(require, exports, module) {
  "use strict";

  var Class = require("base/class"),
      PropertyGroupFactory = require("./property_group_factory"),
      _ = require("underscore"),
      elements = [
        require("./elements/text"),
        require("./elements/form"),
        require("./elements/form_button"),
        require("./elements/button"),
        //video
        require("./elements/video"),
        //image
        require("./elements/image"),
        //area: it's not an element anymore (doesnt extend Base)
        //we delete it from this factory avoiding circular references
        //require("./elements/area"),
        //html
        require("./elements/html"),
        //social
        require("./elements/social"),
        //popup
        require("./elements/popup")
      ];


  var Serialization = {
    fromJSON: function(json, options) {
      var model = module.exports.create(json.name, _.omit(json, "name", "x", "y"), options);
      _.each(model.propertyGroups, function(pg){
        pg.parent = model;
      });
      return model;
    }
  };

  var elementConstructors = _.foldl(elements, function(acc, Constructor) {
    acc[Constructor.prototype.name] = Constructor;
    return acc;
  }, {});

  module.exports = Class.extend({
    constructor: function(options) {
      return module.exports.create(options.elementName,
                                   _.omit(options, "elementName"));
    }
  },
  {
    create: function(elementName, attrs, options) {
      return new elementConstructors[elementName](attrs, options);
    },
    fromJSON: Serialization.fromJSON
  });

});

